/**
 * Catálogo de tutoriales del menú activo.
 * Mantener alineado con:
 * - backend: src/constants/tutorialModules.js
 * - frontend: `key` de cada entrada en moduleTours.js
 *
 * Al agregar un tour nuevo, añade la clave aquí y en moduleTours.js en el mismo PR.
 */
export const TUTORIAL_MODULE_KEYS = Object.freeze([
    'dashboard-operativo',
    'agenda-calendario',
    'agenda-registro',
    'historia-clinica-listado',
    'historia-clinica-registro',
    'patients-listado',
    'patients-registro',
    'studies-registro',
    'inventory-listado',
    'inventory-suppliers-list',
    'inventory-supplier-register',
    'inventory-product-register',
    'movements-incomes',
    'receivables-listado',
    'receivables-registro',
    'receivables-detalle',
    'movements-expenses',
    'movements-types',
    'inventory-purchases',
    'movements-income-view',
    'movements-expense-view',
    'movements-income-register',
    'movements-expense-register',
    'movements-type-register',
    'inventory-purchase-register',
    'crm-board',
    'crm-companies',
    'crm-company-register',
    'studies-listado',
    'inventory-types-listado',
    'inventory-type-register',
    'commitment-types-listado',
    'commitment-type-register',
    'settings-profiles',
    'settings-profile-detail',
    'settings-profile',
    'settings-display',
]);

export const TUTORIAL_MODULE_KEY_SET = new Set(TUTORIAL_MODULE_KEYS);

/** @returns {Record<string, boolean>} */
export const createDefaultTutorialEstado = () =>
    Object.fromEntries(TUTORIAL_MODULE_KEYS.map(key => [key, false]));

/**
 * Fusiona la respuesta remota con el catálogo local.
 * Claves ausentes o desconocidas quedan en `false`; solo las del catálogo se conservan.
 *
 * @param {Record<string, boolean|number|string|null|undefined>} remote
 * @returns {Record<string, boolean>}
 */
export const mergeTutorialEstado = remote => {
    const merged = createDefaultTutorialEstado();

    for (const key of TUTORIAL_MODULE_KEYS) {
        const value = remote?.[key];
        merged[key] = value === true || value === 1 || value === 'true' || value === '1';
    }

    return merged;
};

export const isTutorialModuleKey = key => TUTORIAL_MODULE_KEY_SET.has(key);

/**
 * Compara las claves del catálogo con las definidas en moduleTours.
 * Útil en desarrollo para detectar desincronización temprana.
 *
 * @param {string[]} tourKeys
 */
export const getTutorialCatalogDrift = tourKeys => {
    const tourKeySet = new Set(tourKeys);
    const missingInCatalog = tourKeys.filter(key => !TUTORIAL_MODULE_KEY_SET.has(key));
    const missingInTours = TUTORIAL_MODULE_KEYS.filter(key => !tourKeySet.has(key));

    return {
        inSync: !missingInCatalog.length && !missingInTours.length,
        missingInCatalog,
        missingInTours,
    };
};
